import { Queue } from '@chilipiper/api-type-def'
import { Divider, ScreenReaderOnly, Box, Flex, Text } from '@chilipiper/design-system'
import React from 'react'
import { getAssigneesNames } from '../helpers/helpers'
import { Logo } from '../logo/Logo'
import { GroupMember } from '../group-member'
import { GroupMembersDropdown } from '../group-members-dropdown'
import { BackToTemplates } from './BackToTemplates'
import { PickTitle } from './PickTitle'
import { StyledHeaderContainer } from './styles'
import './book-with.css'

interface Props {
  isMeetingApprovalFlow?: boolean
  isReschedule?: boolean
  queue: Queue
  showBack?: boolean
  templateName?: string
}

export const GroupBookWithHeader = ({
  showBack,
  templateName,
  queue,
  isReschedule,
  isMeetingApprovalFlow,
}: Props) => {
  const assigneeNames = getAssigneesNames(queue.members)
  return (
    <StyledHeaderContainer mb={[0, 8]} width='100%' justifyContent='center' flexDirection='column'>
      <Flex
        py={5}
        bg={['white', 'transparent']}
        w='100%'
        maxWidth='700px'
        justifyContent='space-between'
        alignSelf='center'
      >
        <Flex
          ml={[6, 6, 6, 0]}
          mr={[6, 6, 6, 0]}
          w='100%'
          alignItems='center'
          justifyContent='start'
        >
          {showBack && templateName !== undefined && (
            <BackToTemplates templateName={templateName} />
          )}
          {queue.members.slice(0, 3).map((member: any, index: number) => (
            <GroupMember size={9} key={member.id} member={member} index={index} />
          ))}
          <Flex ml={[2, 4]} flexDirection='column'>
            <Text
              as='h1'
              data-chili-css='book-text'
              className='fabe-title-name'
              color='neutral-dark-80'
              fontWeight={500}
              marginY={0}
            >
              <PickTitle
                isQueue
                isReschedule={isReschedule}
                isMeetingApprovalFlow={isMeetingApprovalFlow}
              />
              <ScreenReaderOnly as='span'>{assigneeNames}</ScreenReaderOnly>
            </Text>
            <Flex mt={1}>
              <Text
                data-test-id='GroupBookWithHeader-members-names'
                data-chili-css='book-members'
                fontWeight={600}
                mb={0}
                mr={2}
              >
                {assigneeNames}
              </Text>
              <GroupMembersDropdown members={queue.members} />
            </Flex>
          </Flex>
        </Flex>
        <Box mr={6} display={['none', 'block']}>
          <Logo />
        </Box>
      </Flex>
      <Divider display={['block', 'none']} />
    </StyledHeaderContainer>
  )
}
